import { useEffect, useLayoutEffect } from 'react';

/**
 * `useLayoutEffect` in the browser, `useEffect` on the server.
 *
 * Anything that has to replace a server-rendered placeholder with its real client value goes
 * through this. The passive effect would work, but it runs *after* paint, so the visitor sees one
 * frame of the placeholder — and React warns that a layout effect can never fire during the
 * prerender, where there is no layout to measure.
 */
export const useIsomorphicLayoutEffect =
  typeof window !== 'undefined' ? useLayoutEffect : useEffect;
